import { render, staticRenderFns } from "./gameList.vue?vue&type=template&id=1040a550&"
import script from "./gameList.vue?vue&type=script&lang=js&"
export * from "./gameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1040a550')) {
      api.createRecord('1040a550', component.options)
    } else {
      api.reload('1040a550', component.options)
    }
    module.hot.accept("./gameList.vue?vue&type=template&id=1040a550&", function () {
      api.rerender('1040a550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/gameList.vue"
export default component.exports